import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconCheck,
  IconCircleXmark,
  IconDownload,
  IconTrashCan,
} from '@coverflex-tech/hypernova';
import { IFile, getFileSize } from '@coverflex-tech/hypernova-utils';
import css from './attachment-preview.module.css';

interface IProps {
  attachment: IFile;
  onRemove?: () => void;
  downloadable?: boolean;
}

const AttachmentPreview = ({ attachment, downloadable, onRemove }: IProps) => {
  const { t } = useTranslation();
  const [previewError, setPreviewError] = useState(false);

  useEffect(() => {
    setPreviewError(false);
  }, [attachment]);

  const isImage = attachment.url || attachment.blob?.type.includes('image');
  return (
    <div className={css.host}>
      {!isImage || previewError ? (
        <>
          {attachment.blob ? (
            <>
              <div className={css.successBadge}>
                <IconCheck />
              </div>
              <div className={css.successLabel}>
                {t('general.fields.file.uploaded')}
              </div>
            </>
          ) : (
            <div className={css.iconHolder}>pdf</div>
          )}
          <div className={css.filename}>
            <span>{attachment.name}</span>
            {!!onRemove && (
              <button
                type="button"
                className={css.removeBtn}
                onClick={onRemove}
              >
                <IconCircleXmark />
              </button>
            )}
          </div>
          {attachment.blob && (
            <div className={css.filesize}>
              {getFileSize(attachment.blob?.size ?? 0)}
            </div>
          )}
          {downloadable && (
            <div className={css.imageActions}>
              <a
                className={css.downloadPdfBtn}
                href={attachment.url}
                download={attachment.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconDownload />
              </a>
            </div>
          )}
        </>
      ) : (
        <>
          <img
            className={css.image}
            alt={attachment.name}
            src={attachment.url}
            onError={() => setPreviewError(true)}
          />
          <div className={css.imageActions}>
            {onRemove && (
              <button
                type="button"
                className={css.actionButton}
                onClick={onRemove}
              >
                <IconTrashCan className={css.actionIcon} />
              </button>
            )}
            {downloadable && (
              <a
                className={css.downloadPdfBtn}
                href={attachment.url}
                download={attachment.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconDownload />
              </a>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AttachmentPreview;
